module.exports = __webpack_public_path__ + "c59292fe1c81376f9018ac750419402a.png";